var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGreyChevronUp = function SvgGreyChevronUp(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2069 15.2133C18.8163 15.6039 18.1832 15.6039 17.7926 15.2133L12.4998 9.92044L7.20686 15.2133C6.81634 15.6039 6.18317 15.6039 5.79265 15.2133C5.40212 14.8228 5.40212 14.1896 5.79265 13.7991L11.7926 7.79912C12.1832 7.40859 12.8163 7.40859 13.2069 7.79912L19.2069 13.7991C19.5974 14.1896 19.5974 14.8228 19.2069 15.2133Z",
    fill: "#E0E2E3"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGreyChevronUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "grey-chevron-up.a97c5db5bb624dfb5d89e06b99999919.svg";